import { render, staticRenderFns } from "./product-collection.vue?vue&type=template&id=272afcf8"
import script from "./product-collection.vue?vue&type=script&lang=js"
export * from "./product-collection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports